<template>
  <div class="other-tooltip">
    <span
      :ref="`${colKey}`"
      class="opacity0"
    >{{ text }}</span>
    <a-tooltip
      :visible.sync="visible"
      overlay-class-name="td-tooltip"
      @visibleChange="visibleChange"
    >
      <span slot="title">
        {{ text }}
      </span>
      {{ text }}
    </a-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    colKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
  },
  methods: {
    visibleChange (show) {
      let $ele = this.$refs[`${this.colKey}`]
      let contentWidth = $ele && $ele.clientWidth
      // let contentWidth = $ele && $ele.getBoundingClientRect().width
      // let item = this.columns.find(item => item.key === this.colKey) || {}
      // let tdWidth = item.width - 32 || 0
      let tdWidth = 190

      if (show) {
        if (tdWidth && contentWidth && tdWidth < contentWidth) {
          this.visible = true
        } else {
          this.visible = false
        }
      } else {
        this.visible = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .other-tooltip {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .opacity0 {
      opacity: 0;
      position: absolute ;
      z-index: -1;
    }
    // .font_normal {
    //   font-size: 14px;
    //   color: #333;
    // }
  }
</style>
